import { BaseFactory } from '../base.factory';
import { Station } from '../../model/station';
import merge from 'lodash/merge';

export class GDSStationFactory extends BaseFactory {

    constructor() {
        super(true);
        // this.requestConfig.baseURL = `${process.env.BASE_API}`;
        this.requestConfig.baseURL = `${process.env.VUE_APP_API_URL}`;
        this.requestConfig.headers = merge({'X-Device': 'MARKETPLACE'}, this.requestConfig.headers);
    }

    public getStationsForCompany = async () => {
        try {
            const path = '/city/by-company';
            // const result = await this.get(path, {baseURL: `${process.env.BASE_API}`});
            const result = await this.get(path, {baseURL: `${process.env.VUE_APP_API_URL}`});
            return result[0].id;
        } catch (error) {
            throw error;
        }

    }
}
